/**
 * Clasificacion de marcadores por antiguedad de ultima visita (modo explorador).
 * - never: nunca visitado (azul brand)
 * - reciente: visitado en los ultimos 7 dias (verde)
 * - mes: visitado en los ultimos 30 dias (ambar)
 * - stale: visitado hace mas de 30 dias (gris)
 */
export type MarkerVisitStatus = "never" | "reciente" | "mes" | "stale";

const DAY_MS = 24 * 60 * 60 * 1000;

export function classifyMarker(
  lastVisitedAt: string | null,
  now: Date = new Date(),
): MarkerVisitStatus {
  if (!lastVisitedAt) return "never";
  const elapsed = now.getTime() - new Date(lastVisitedAt).getTime();
  if (elapsed < 7 * DAY_MS) return "reciente";
  if (elapsed < 30 * DAY_MS) return "mes";
  return "stale";
}

/**
 * Clases Tailwind de fondo para el dot del marcador por estado.
 */
export const MARKER_STATUS_BG: Record<MarkerVisitStatus, string> = {
  never: "bg-brand-light",
  reciente: "bg-emerald-500",
  mes: "bg-amber-400",
  stale: "bg-slate-400",
};

export const MARKER_STATUS_LABEL: Record<MarkerVisitStatus, string> = {
  never: "Sin visitas",
  reciente: "Visita reciente",
  mes: "Visitado este mes",
  stale: "Ultima visita > 1 mes",
};
